export default "__VITE_ASSET__57148314__"